import { render, staticRenderFns } from "./zhengzhifagui.vue?vue&type=template&id=a2996852&scoped=true"
import script from "./zhengzhifagui.vue?vue&type=script&lang=js"
export * from "./zhengzhifagui.vue?vue&type=script&lang=js"
import style0 from "./zhengzhifagui.vue?vue&type=style&index=0&id=a2996852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2996852",
  null
  
)

export default component.exports